module.exports = __webpack_public_path__ + "static/4-before.ea3cf3d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/full-size/4-before.jpg
// module id = 440
// module chunks = 221374088121123